<template>
  <div class="profile-block profile-name">
    <div class="profile-name__content">
      <div class="profile-name__full-name clearfix">
        <avatar class="profile-name__photo visible-xs-block"
                :upic="user.getUpic()"
                :name="user.getLastName()"
                :size="size">
        </avatar>
        <div class="profile-name__name-text">
          <span v-if="user.getLastName()">{{ user.getLastName() }}</span>
          <span v-if="user.getLastName()">{{ user.getFirstName() }}</span>
          <span v-if="user.getMiddleName()">{{ user.getMiddleName() }}</span>
        </div>
      </div>
      <div class="profile-name__post">
        <template v-if="user.getOrgs()">
          <posts-in-row :posts="user.getPosts()"></posts-in-row>
        </template>
        <template v-else>{{ $t('labels.position_not_checked') }}</template>
      </div>
    </div>
    <div v-if="user.getStatus() !== 'ACTIVE'" class="profile-name__status">
      <div class="profile-name__status-button">{{ $t('labels.user_disable') }}</div>
      <el-popover
        placement="top"
        width="200"
        trigger="click"
        :content="$t('labels.activating_user_with_admin')">
        <div class="profile-name__status-help" slot="reference">?</div>
      </el-popover>
    </div>
    <router-link v-if="isMyProfile || admin"
                 class="profile-name__edit-profile visible-xs-block"
                 :to="{ name: isMyProfile && !admin ? 'profileEdit' : 'userEdit', params: { id: user.getId() } }">
      <i class="el-icon-edit"></i>{{ $t('common.dropdown_menu.edit_profile') }}
    </router-link>
  </div>
</template>
<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import PostsInRow from 'src/components/Users/PostsInRow.vue'
  import {USER_STATUS_ACTIVE, USER_ROLE_ADMIN} from '@/constants';

  export default {
    props: {
      user: {
        type: Object,
        default: () => {
        }
      },
      size: String,
      editLink: String,
      perms: {
        type: Object,
        default: () => {
        }
      },
      isMyProfile: Boolean
    },
    components: {
      avatar,
      PostsInRow
    },
    methods: {
      isUserSuperAdmin () {
        /* const SUPER_ADMIN_NAME = 'superadmin'
        if (this.user.roles && this.user.roles.indexOf(SUPER_ADMIN_NAME) >= 0) {
          return true
        } */
      },
      statusToText (status) {
        switch (status) {
          case USER_STATUS_ACTIVE:
            return this.$t('labels.status_active');
          default:
            return this.$t('labels.status_closed');
        }
      }
    },
    computed: {
      admin () {
        if (this.$store.state.user.user) {
          return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
        }
        return false
      },
      isPublicAndActive () {
        /* if (this.user.status !== 'active') {
          return false
        }
        let isPublic = false
        for (const org of this.userModel.getOrgs()) {
          if (org.public) {
            isPublic = true
          }
        }
        return isPublic */
      },
      userModel () {
        // return this.$store.state.users.users[this.user._id]
      },
      isSelf () {
        // return this.$store.state.users.user.getId() === this.userModel.getId();
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .profile-block {
    &.profile-name {
      padding-bottom: 15px;
    }
  }

  .profile-name {
    &__content {
      padding-right: 170px;
      @media (max-width: $screen-lg) {
        padding-right: 0;
      }
    }

    &__photo {
      width: 80px;
      height: 80px;
      float: left;
      margin-right: 15px;
    }

    &__full-name {
      margin-bottom: 10px;
      font-size: 20px;
      color: #333333;
      line-height: 23px;
      font-weight: 700;

      @media (max-width: 360px) {
        font-size: 14px !important;
        line-height: 1.2 !important;
      }
    }

    &__name-text {
      display: inline-block;
      margin-right: 30px;
      word-wrap: break-word;
      max-width: 100%;
      font-weight: bold;

      @media (max-width: $screen-sm) {
        display: block;
        font-size: 16px;
      }
    }

    &__post {
      font-size: 14px;
      color: $secondary-font-color;
    }

    &__specialities {
      padding-top: 10px;
      border-top: 1px solid $light-border-color;
      color: #333333;
    }

    &__specialities-items {
      padding-top: 10px;
    }

    &__specialities-label {
      color: $secondary-font-color;
      margin-right: 5px;

      @media (max-width: $screen-sm) {
        display: block;
      }
    }

    &__button {
      position: absolute;
      right: 30px;
      top: 17px;
      border-color: #2F80ED;
      color: #2F80ED;

      @media (max-width: $screen-lg) {
        position: static;
        margin-top: 15px;
      }

      @media (max-width: $screen-sm) {
        margin-bottom: 15px;
      }
    }

    &__status {
      position: absolute;
      right: 30px;
      top: 17px;

      @media (max-width: $screen-lg) {
        position: static;
        margin-top: 15px;
      }

      @media (max-width: $screen-sm) {
        margin-bottom: 15px;
      }
    }

    &__status-button {
      display: inline-block;
      position: relative;
      line-height: 1;
      white-space: nowrap;
      background: #fff;
      border: 1px solid #F25556;
      color: #F25556;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      padding: 12px 20px 12px 30px;
      font-size: 14px;
      border-radius: 4px;

      &:before {
        content: '';
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: #F25556;

      }
    }

    &__status-help {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-left: 8px;
      border: 1px solid #BFBFBF;
      border-radius: 100%;
      color: #BFBFBF;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      font-weight: 400;
      cursor: pointer;
    }

    &__edit-profile {
      margin: 15px -15px 0 -15px;
      padding: 15px 15px 0 15px;
      border-top: 1px solid $light-border-color;
      text-align: center;
      color: $secondary-font-color;

      i {
        margin-right: 10px;
      }
    }

    .super-admin-ident {
      display: block;
      margin-bottom: 10px;
    }
  }
</style>